import {
  getMessagingChatLocationAuthRetrieveQueryKey,
  getMessagingChatRetrieveQueryKey,
  messagingChatLocationAuthRetrieve,
  messagingChatRetrieve,
} from "@sidegigllc/api/client";
import { queryOptions } from "@tanstack/react-query";
import type { WarmableQuery } from "routing/warmQueries";

export const locationAuthQuery = ({ locationId }: { locationId: number }) =>
  queryOptions({
    queryKey: getMessagingChatLocationAuthRetrieveQueryKey(locationId),
    queryFn: ({ signal }) => messagingChatLocationAuthRetrieve(locationId, { signal }),
  });

export const chatTokenQuery = ({ chatToken }: { chatToken: string }) =>
  queryOptions({
    queryKey: getMessagingChatRetrieveQueryKey(chatToken),
    queryFn: ({ signal }) => messagingChatRetrieve(chatToken, { signal }),
  });

export const inboxQueries = ({ locationId }: { locationId: number | undefined }): Array<WarmableQuery> =>
  locationId ? [locationAuthQuery({ locationId })] : [];

export const chatTokenQueries = (input: { chatToken: string }): Array<WarmableQuery> => [chatTokenQuery(input)];
